import styled from "styled-components";
import MagicText from "@shared/atoms/MagicText";
import MagicImage from "@shared/atoms/MagicImage";
import CreateAccountForm from "@components/CreateAccount/CreateAccountForm";
import { theme } from "@constants/theme";

export const CreateAccountContainer_div = styled.div`
  margin-top: 34px;
  margin-bottom: 50px;
  margin: 34px 0 50px 0;
  padding: 0 24px;

  @media ${(props) => props.theme.device.tablet} {
    margin: 56px auto 100px auto;
  }

  @media ${(props) => props.theme.device.laptop} {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    max-width: 1060px;
  }
`;

export const CreateAccountForm_div = styled(CreateAccountForm)`
  max-width: 504px;
  width: 100%;
  margin: 40px auto 0 auto;

  @media ${(props) => props.theme.device.laptop} {
    width: 50%;
    margin: 0 0 0 20px;
  }
`;

export const MagicText_h1 = styled(MagicText)`
  font-size: 40px;
  line-height: 150%;
  font-family: ${theme.fonts.GTAmericaBold};
  max-width: 504px;
  width: 100%;
  margin: 40px auto 40px auto;

  @media ${(props) => props.theme.device.mobileL} {
    font-size: 48px;
  }

  @media ${(props) => props.theme.device.laptop} {
    font-size: 64px;
    margin: 0 0 40px 0;
  }
`;

export const Text_span = styled.span`
  display: block;
  margin-bottom: 30px;
`;

export const MagicImage_lottie = styled(MagicImage)`
  width: 100%;
  max-width: 430px;
  margin-bottom: 16px;
`;
